import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "code" ]

  connect() {
  }

  create() {
  	const genRanHex = size => [...Array(size)].map(() => Math.floor(Math.random() * 16).toString(16)).join('');
    this.codeTarget.value = `${genRanHex(6)}-${genRanHex(6)}-${genRanHex(6)}-${genRanHex(6)}`;
  }
}